import React, {Fragment, useState, useEffect, useRef} from 'react'
import axios from "axios";
import IncomingListModal from "./IncomingListModal";
import CdnPath from "../../services/cdn_path";


const IncomingCommunications = ({adminId, csp_basic_url}) => {
    const [openCommCount, setOpenCommCount] = useState(0)
    const [showModal, setShowModal] = useState(false)
    const [openSlas, setOpenSlas] = useState([])
    const incomingModalRef = useRef(null)

    useEffect(() => {
        getOpenCommCount()

        const timer = setInterval(() => {
            getOpenCommCount()
        }, 15000)

        return () => clearInterval(timer)
    }, [])

    useEffect( () => {
        if(showModal) {
            document.addEventListener("click", closeModal);
        }
        else {
            document.removeEventListener('click', closeModal);
        }
    }, [showModal])

    const getOpenCommCount = () => {
        if (adminId) {
            axios.post(`/api/backend/admins/incoming_count?admin_id=${adminId}`)
                .then(res => {
                    const count = res.data.incoming_count
                    if (openCommCount != count) {
                        setOpenCommCount(count)
                    }
                })
        }
    }

    const onClick = (e) => {
        if (showModal) {
            closeModal(e)
            return
        }
        axios.get(`/api/backend/admins/open_slas_data?admin_id=${adminId}`)
            .then(res => {
                setOpenSlas(res.data)
                setShowModal(true)
            })
    }


    const closeModal = (e) => {
        if (incomingModalRef.current && incomingModalRef.current.contains(e.target)) {
            return
        }
        setShowModal(false )
    }

    return (
        <Fragment>
            <span id={'incoming-communication-icon'} onClick={onClick}>
                <img src={CdnPath("backend/icons/incoming-communication-icon.svg")} alt="incoming-icon"/>
                { openCommCount > 0 ? <span className={'badge'}>{openCommCount}</span> : null }
            </span>
            {
                showModal && openSlas.length > 0 ? <div ref={incomingModalRef}><IncomingListModal openSlas={openSlas} csp_basic_url={csp_basic_url} /></div> : null
            }
        </Fragment>
    )
}

export default IncomingCommunications